import Form from "../components/Form";

function ContactPage() {
    return (
        <div className="container">
            <h2 className="text-center my-5">Reach Out To Me!</h2>
            <p className="text-center">Feel free to contact me if you have any questions, or would like to discuss any work-related opportunties! I'm quick to respond, and would love to get in touch.</p>

            <Form />
        </div>
    );
}

export default ContactPage;